module.exports = __webpack_public_path__ + "static/implementation-0286a021d8025275252f354a68d8712c.svg";